import React from 'react'

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid2, Typography, TextField, IconButton, Box, MenuItem } from '@mui/material'
import * as Yup from 'yup'
import { Formik, Form, Field } from 'formik'
import { Close, UploadFile, Save } from '@mui/icons-material';
import { myApi } from '../../../../config/axiosConfig'
import Swal from 'sweetalert2';
import { base_url_clean } from '../../../../config/urls';

import plantilla from '../../../../assets/img/inspecciones/temas/plantilla.png'
function ModalAgregarTemas({ open, onClose, isEditing = false, selectedTema, refresh }) {

    /*=============================================
    DEFINICIÓN DE VALORES INICIALES
    =============================================*/
    const initialValues = {
        nombreTema: selectedTema ? selectedTema.nombre_tema : '',
        descripcionTema: selectedTema ? selectedTema.descripcion_tema : '',
        imagen: selectedTema ? selectedTema.imagen_url : "",
        previewUrl: selectedTema ? `${base_url_clean}img/temas${selectedTema.imagen_url}` : '',
        tipoTema: selectedTema ? selectedTema.tipo_tema : 'imagen',
    }

    /*=============================================
    DEFINICIÓN DE LA VALIDACIÓN DEL FORMULARIO DE TEMAS
    =============================================*/
    const validationSchema = Yup.object().shape({
        nombreTema: Yup.string().required('Campo obligatorio'),
        descripcionTema: Yup.string().required('Campo obligatorio'),
        tipoTema: Yup.string().required('Campo obligatorio'),
        imagen: Yup.mixed().test(
            'imagen-condicional',
            'La imagen es obligatoria',
            function (value) {
                const { tipoTema } = this.parent;
                if (tipoTema === 'imagen') {
                    return !!value; // solo es obligatorio si es tipo imagen
                }
                return true; // si no es imagen, no se requiere
            }
        ),
    })

    /*=============================================
    FUNCION QUE AGREGA LOS TEMAS
    =============================================*/
    const handleSubmitForm = async (values) => {

        if(isEditing){
            try {
                const formData = new FormData();
                formData.append("imagen", values.imagen);
                formData.append("nombre_tema", values.nombreTema);
                formData.append("descripcion_tema", values.descripcionTema);
                formData.append("id_tema", selectedTema.id_tema);
                formData.append("fileName", values.imagen.name);
                formData.append("tipo_tema", values.tipoTema);
                const response = await myApi.put('/inspeccion/temas/updateTema', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                if (response.data.success) {
                    onClose()
                    Swal.fire({
                        icon: 'success',
                        title: 'Tema editado',
                    });
                    await refresh();
                } else {
                    onClose()
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al editar tema',
                        customClass: {
                            container: 'swal2-container'
                        }
                    });
                }
            } catch (error) {
                console.error(error)
                Swal.fire({
                    icon: 'error',
                    title: 'Error al editar tema',
                });
            }

        }else{
            try {
                const formData = new FormData();
                formData.append("imagen", values.imagen);
                formData.append("nombre_tema", values.nombreTema);
                formData.append("descripcion_tema", values.descripcionTema);
                formData.append("tipo_tema", values.tipoTema);
                const response = await myApi.post('/inspeccion/temas/insertTema', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                if (response.data.success) {
                    onClose()
                    Swal.fire({
                        icon: 'success',
                        title: 'Tema agregado',
                    });
                    await refresh();
                } else {
                    onClose()
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al agregar tema',
                        customClass: {
                            container: 'swal2-container'
                        }
                    });
                }
            } catch (error) {
                console.error(error)
                Swal.fire({
                    icon: 'error',
                    title: 'Error al agregar tema',
                });
            }
        }
    }



    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {isEditing ? 'Editar Tema' : 'Agregar Tema'}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid2 container spacing={2} direction={'column'}>
                    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmitForm}>
                        {({ values, errors, touched, setFieldValue }) => (
                            <Form autoComplete='off'>
                                <Grid2 container direction="row" spacing={2} sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', width: '100%' }}>
                                    <Grid2 size={{ xs: 6, md: 6 }}>
                                        <Field
                                            as={TextField}
                                            name="nombreTema"
                                            label="Nombre del tema"
                                            fullWidth
                                            value={values.nombreTema}
                                            error={touched.nombreTema && Boolean(errors.nombreTema)}
                                            helperText={touched.nombreTema && errors.nombreTema}
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 6 }}>
                                        <Field
                                            as={TextField}
                                            name="descripcionTema"
                                            label="Descripción del tema"
                                            fullWidth
                                            value={values.descripcionTema}
                                            error={touched.descripcionTema && Boolean(errors.descripcionTema)}
                                            helperText={touched.descripcionTema && errors.descripcionTema}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <Field
                                            as={TextField}
                                            select
                                            name="tipoTema"
                                            label="Tipo de Tema"
                                            fullWidth
                                            value={values.tipoTema}
                                            onChange={(e) => setFieldValue("tipoTema", e.target.value)}
                                            error={touched.tipoTema && Boolean(errors.tipoTema)}
                                            helperText={touched.tipoTema && errors.tipoTema}
                                        >
                                            <MenuItem value="imagen">Imagen</MenuItem>
                                            <MenuItem value="matriz">Matriz</MenuItem>
                                        </Field>
                                        {values.tipoTema === 'matriz' && (
                                            <Box mt={2}>
                                                <Typography variant="subtitle2">Vista previa tipo matriz:</Typography>
                                                <img src={plantilla} alt="vista tipo matriz" width={200} />
                                            </Box>
                                        )}
                                    </Grid2>
                                    {values.tipoTema === 'imagen' && (
                                        <>
                                            <input
                                                id="imagen-input"
                                                type="file"
                                                accept="image/*"
                                                hidden
                                                onChange={(event) => {
                                                    const file = event.currentTarget.files[0];
                                                    if (file) {
                                                        setFieldValue("imagen", file);
                                                        setFieldValue("previewUrl", URL.createObjectURL(file));
                                                    }
                                                }}
                                            />
                                            <label htmlFor="imagen-input">
                                                <Button
                                                    variant="outlined"
                                                    component="span"
                                                    startIcon={<UploadFile />}
                                                    fullWidth
                                                >
                                                    {values.imagen ? 'Cambiar imagen' : 'Seleccionar imagen'}
                                                </Button>
                                            </label>

                                            {values.imagen && values.previewUrl && (
                                                <Box
                                                    mt={2}
                                                    sx={{
                                                        position: 'relative',
                                                        width: 100,
                                                        height: 100,
                                                        border: '1px solid #ccc',
                                                        borderRadius: 2,
                                                        overflow: 'hidden',
                                                    }}
                                                >
                                                    <img
                                                        src={values.previewUrl}
                                                        alt="preview"
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                    />
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => {
                                                            setFieldValue("imagen", null);
                                                            setFieldValue("previewUrl", null);
                                                        }}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            right: 0,
                                                            color: '#fff',
                                                            backgroundColor: 'rgba(0,0,0,0.6)',
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(0,0,0,0.8)'
                                                            }
                                                        }}
                                                    >
                                                        <Close fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            )}

                                            {touched.imagen && errors.imagen && (
                                                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                                                    {errors.imagen}
                                                </Typography>
                                            )}
                                        </>
                                    )}
                                </Grid2>
                                <DialogActions>
                                    <Button onClick={onClose} variant="contained">
                                        Cerrar
                                    </Button>
                                    <Button type="submit" variant="contained" color="primary" startIcon={<Save />}>
                                        Guardar
                                    </Button>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </Grid2>

            </DialogContent>
            
        </Dialog>
    )
}

export default ModalAgregarTemas